import { Box, Divider, Skeleton } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    skeletonGrid: {
        display: "grid",
        gridTemplateColumns: "5fr 4fr",
        gap: "3.5rem",
        width: "100%",
        maxWidth: "60rem",
    },
    skeletonLeftColumn: {
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
    },
    skeletonRightCard: {
        borderRadius: ".75rem",
        background: theme.palette.tailwind.slate[50],
        padding: "1rem 1.5rem 1.5rem",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
    },
}))

export function ConfirmBookingSkeleton() {
    const { classes } = useStyles()

    return (
        <>
            <Box className={classes.skeletonGrid}>
                <Box className={classes.skeletonLeftColumn}>
                    <Skeleton variant="rounded" width="100%" height="3.5rem" />
                    <Skeleton variant="rounded" width="100%" height="3.5rem" />
                    <Skeleton variant="rounded" width="100%" height="3.75rem" />
                    <Skeleton variant="rounded" width="100%" height="3.75rem" />
                </Box>
                <Box className={classes.skeletonRightCard}>
                    <Skeleton variant="rounded" width="60%" height="1.5rem" />
                    <Skeleton variant="rounded" width="80%" height="1rem" />
                    <Divider />
                    <Skeleton variant="rounded" width="40%" height="1.25rem" />
                    <Skeleton variant="rounded" width="100%" height="2.5rem" />
                </Box>
            </Box>
            <Skeleton variant="rounded" width="15rem" height="2.5rem" />
        </>
    )
}
